import { User } from '../types/User';

export const fullName = (user: User): string => `${user.first_name} ${user.last_name}`;
